import React from "react";
import ForgotPasswordLayer from "../components/General/ForgotPasswordLayer";


const ForgotPasswordPage = () => {
  return (
    <>

      {/* ForgotPasswordLayer */}
      <ForgotPasswordLayer />

    </>
  );
};

export default ForgotPasswordPage;
